var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"loader-wrapper"}},[_c('div',{staticClass:"loader"},[_c('div',{staticClass:"loader-content center-xy"},[_c('div',{staticClass:"loader-spinner"})])])])
}
var staticRenderFns = []

export { render, staticRenderFns }